import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { CustomerBillingCustomerModel } from '@fi-app/customer-billing/customer-billing-customer/customer-billing-customer.model';

@Component({
    selector: 'fi-customer-billing-customer-unit-edit-credit-usage-information',
    templateUrl: './customer-billing-customer-unit-edit-credit-usage-information.component.html',
    styleUrls: ['./customer-billing-customer-unit-edit-credit-usage-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-customer-unit-edit-credit-usage-information' },
    standalone: false,
})
export class CustomerBillingCustomerUnitEditCreditUsageInformationComponent {
    @Input() customer: CustomerBillingCustomerModel;
}
